<div
  class="flex gap-3 max-sm:gap-1 text-13 max-sm:text-11 overflow-x-auto hidden-scrollbar"
  [ngClass]="{
    'bg-white header-tab-bar': filtersOptions === 'header'
  }"
>
  <div
    class="cursor-pointer flex items-center gap-1 relative pb-3 pr-3 max-sm:pb-2"
    [ngClass]="{
      'text-grey-2': tab.title !== 'InLive' && i !== selectedIndex,
      selected: i === selectedIndex,
      'text-blue': i === selectedIndex && tab.title !== 'InLive',
      'text-red-2': tab.title === 'InLive',
      'w-[50%] justify-center gap-3 text-15 max-sm:text-13 uppercase pt-3 px-3':
        filtersOptions === 'header',
      ' bg-[#e5e4e432]': filtersOptions === 'header' && i === selectedIndex
    }"
    *ngFor="let tab of optionsFilter; let i = index"
    (click)="handleModelChange(i)"
  >
    <img
      alt="loading..."
      *ngIf="tab.hasIcon"
      [src]="urlIcon + tab.hasIcon"
      [ngClass]="{
        'w-[30px] max-sm:w-[20px]': filtersOptions === 'header',
        'max-sm:w-[6px]': filtersOptions !== 'header'
      }"
    />
    <span
      class="font-roboto-500 text-nowrap"
      [ngClass]="{
        separator:
          i !== optionsFilter.length - 1 && tab.stats != 0 && !tab.stats,
        'pr-6 max-sm:pr-4': tab.stats != 0 && !tab.stats,
        'font-roboto-800': filtersOptions === 'header'
      }"
      >{{ tab.title | translate }}</span
    >
    <span
      class="font-sofia-sans-400 pr-6 max-sm:pr-4"
      [ngClass]="{
        separator: i !== optionsFilter.length - 1,
      }"
      *ngIf="tab.stats || tab.stats === 0"
      >({{ tab.stats }})</span
    >
  </div>
</div>
